(function () {
  'use strict';
  function init() {
    var gallery = document.querySelector('[data-rg-root]');
    if (!gallery) return;
    var chips = gallery.querySelectorAll('.rg-chip[href]');
    var prefetched = {};
    chips.forEach(function (chip) {
      chip.addEventListener('mouseenter', function () {
        var href = chip.getAttribute('href');
        if (prefetched[href]) return;
        prefetched[href] = true;
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = href;
        document.head.appendChild(link);
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

document.addEventListener('DOMContentLoaded', function() {
  var btn = document.querySelector('.rg-loadmore');
  if (!btn) return;
  var tmpl = document.getElementById('rg-more-tiles');
  if (!tmpl) return;
  var firstTile = document.querySelector('.rg-tile');
  if (!firstTile) return;
  var grid = firstTile.parentNode;
  var batch = parseInt(btn.getAttribute('data-batch'), 10) || 60;
  btn.addEventListener('click', function() {
    var frag = tmpl.content;
    for (var i = 0; i < batch; i++) {
      var next = frag.firstElementChild;
      if (!next) break;
      grid.appendChild(next);
    }
    var remaining = frag.querySelectorAll('.rg-tile').length;
    if (remaining === 0) {
      btn.classList.add('rg-loadmore--hidden');
    }
  });
});
